import React from 'react'
import { Stamp, Tooltip } from './style'

const dataTestLabel = 'seal_trocatroco'
const StampTrocaComTroco = ({ daInfo = false }) => (
  <Stamp daInfo={daInfo} data-test-component={dataTestLabel}>
    <Tooltip>Troca + Troco</Tooltip>
  </Stamp>
)

export default StampTrocaComTroco
